module.exports = __webpack_public_path__ + "img/update-icon.b5bbb92a.svg";